module.exports = __webpack_public_path__ + "static/media/notfound.577cf9c4.jpeg";